<template>
  <div
    id="js-container"
    class="container detail"
    :class="{'menubar-padding' : isMenubarFixed}"
    data-test="container"
  >
    <main
      id="main"
      class="content-view content js-content-view js-content"
      data-content="main"
      data-depth="0"
    >
      <div class="content-inner">
        <section class="mod-detail-job">
          <a href="javascript:void(0);">
            <header class="mod-page-title">
              <h5 class="inner">
                <span data-test="company-name">{{ jobInfo.companyName }}</span>
                <span class="arrow right" />
              </h5>
            </header>
          </a>
          <preview-job-header-for-sp
            :job-name="jobInfo.name.value"
            :employment-status="jobInfo.employmentStatus"
            :salary-map="jobInfo.salaryMap"
            :overtime-work-hours="jobInfo.overtimeWorkHours"
            :entry-form-type="jobInfo.entryFormType"
            :can-casual-interview="jobInfo.canCasualInterview"
          />
          <preview-job-tab-for-sp class="head" />
          <preview-job-detail-button-area-for-sp
            v-show="showDetailButton"
            class="scroll fade-in"
            style="position: fixed; bottom: 0px; z-index: 10;"
            :entry-form-type="jobInfo.entryFormType"
            :can-casual-interview="jobInfo.canCasualInterview"
          />
          <div
            ref="menubar"
            class="mod-inpage-link"
            :class="{'is-fixed':isMenubarFixed}"
            data-test="menubar"
          >
            <ul class="mod-inpage-link-inner top">
              <template v-for="(menu, i) in menubarData">
                <li
                  v-if="menu.isShow"
                  :key="i"
                >
                  <a
                    :class="{'is-current' : menu.isCurrent}"
                    :data-test="`menu-${i}`"
                    @click="scrollTo(menu.scrollTarget)"
                  >{{ menu.name }}</a>
                </li>
              </template>
            </ul>
          </div>
          <preview-job-main-article-for-sp
            :main-photo-id="jobInfo.mainPhotoId"
            :job-name="jobInfo.name.value"
            :job-pr-icons="jobInfo.prIcons"
            :main-title="jobInfo.mainTitle.value"
            :main-body="jobInfo.mainBody.value"
            @onLoadImage="onLoadImageAction()"
            @toggle="setCheckPoint()"
          />
          <div ref="showDetailButton" />
          <preview-job-content-section>
            <preview-job-content-title title="募集背景" />
            <preview-job-content-for-sp
              :text="jobInfo.background.value"
            />
          </preview-job-content-section>
          <div
            id="description"
            ref="description"
            class="mod-inpage-link"
            style="visibility:hidden; height:0;"
          />
          <preview-job-content-section>
            <preview-job-content-title title="仕事内容" />
            <preview-job-content-for-sp
              :text="jobInfo.description.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.projectsDealing.value"
              title="案件例"
              :text="jobInfo.projectsDealing.value"
            >
              <preview-job-ribbon text="エンジニア限定取材" />
            </preview-job-content-for-sp>
            <preview-job-content-for-sp
              v-if="jobInfo.commodity.value"
              title="手がける商品・サービス"
              :text="jobInfo.commodity.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.scopeJob.value"
              title="開発環境・業務範囲"
              :text="jobInfo.scopeJob.value"
            >
              <preview-job-ribbon text="エンジニア限定取材" />
            </preview-job-content-for-sp>
            <preview-job-content-for-sp
              v-if="jobInfo.salesStyle.value"
              title="営業スタイル"
              :text="jobInfo.salesStyle.value"
            >
              <preview-job-ribbon text="営業職限定取材" />
            </preview-job-content-for-sp>
            <preview-job-content-for-sp
              v-if="jobInfo.merchandiseDeal.value"
              title="扱う商材"
              :text="jobInfo.merchandiseDeal.value"
            >
              <preview-job-ribbon text="営業職限定取材" />
            </preview-job-content-for-sp>
            <preview-job-content-for-sp
              v-if="showAttentionPoint1"
              :title="jobInfo.attentionPointCaption1.value"
              :text="jobInfo.attentionPointBody1.value"
            />
            <preview-job-content-for-sp
              v-if="showAttentionPoint2"
              :title="jobInfo.attentionPointCaption2.value"
              :text="jobInfo.attentionPointBody2.value"
            />
            <preview-job-content-time-schedule-for-sp
              v-if="showTimeSchedule"
              :time-schedules="jobInfo.timeSchedules"
              :caption="jobInfo.timeScheduleTitle.value"
            />
          </preview-job-content-section>
          <preview-job-content-section
            v-if="showPassChild"
            data-test="pass-child"
          >
            <preview-job-content-title title="身につくスキル・キャリアパス" />
            <preview-job-content-for-sp
              v-if="jobInfo.careerPath.value"
              :text="jobInfo.careerPath.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.supportAfterJoin.value"
              title="入社後の成長サポート"
              :text="jobInfo.supportAfterJoin.value"
            />
          </preview-job-content-section>
          <div
            id="qualification"
            ref="qualification"
            class="mod-inpage-link"
            style="visibility:hidden; height:0;"
          />
          <preview-job-content-section>
            <preview-job-content-title title="応募資格" />
            <preview-job-content-for-sp
              :text="jobInfo.requiredSkill.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.welcomeSkill.value"
              title="歓迎する経験・スキル"
              :text="jobInfo.welcomeSkill.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.recruitExample.value"
              title="過去の採用例"
              :text="jobInfo.recruitExample.value"
            />
            <preview-job-content-orients-for-sp
              v-if="showSuitablePerson"
              :suitable="jobInfo.suitableForThisJob.value"
              :not-suitable="jobInfo.notSuitableForThisJob.value"
            />
          </preview-job-content-section>
          <preview-job-content-section>
            <preview-job-content-title title="雇用形態" />
            <!--
              preview-job-content-remarks-for-sp 毎にブロック（線）で区切られる。
              「試用期間の雇用形態備考（trialPeriodEmploymentStatusRemarks）」の表示位置が
              「試用期間（trialPeriodText）」の表示有無によって変わる為、雇用形態備考の表示位置を「試用期間」で判定している。
              ・「試用期間」が設定されている場合、タイトル「試用期間」のブロック内、試用期間の下に表示。
              ・「試用期間」が設定されていない場合、タイトル「試用期間」が非表示、雇用形態の下に表示する。
            -->
            <preview-job-content-remarks-for-sp
              :text="employmentStatusText"
              v-bind="trialPeriodRemarksProps"
            />
            <preview-job-content-remarks-for-sp
              v-if="jobInfo.trialPeriodText"
              title="試用期間"
              :text="jobInfo.trialPeriodText"
              :remarks="jobInfo.trialPeriodEmploymentStatusRemarks.value"
            />
          </preview-job-content-section>
          <preview-job-content-section>
            <preview-job-content-title title="想定給与" />
            <preview-job-content-for-sp
              :text="jobInfo.salary.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.deemedOvertimeHoursText"
              title="固定残業代について"
              :text="jobInfo.deemedOvertimeHoursText"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.salaryExample.value"
              title="実際の給与例"
              :text="jobInfo.salaryExample.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.bonus.value"
              title="賞与について"
              :text="jobInfo.bonus.value"
            />
            <preview-job-content-for-sp
              v-if="!!jobInfo.salaryByWorkplaceAddressListText.value"
              title="勤務地別給与"
              :text="jobInfo.salaryByWorkplaceAddressListText.value"
            />
          </preview-job-content-section>
          <preview-job-content-section>
            <preview-job-content-title title="勤務時間" />
            <preview-job-content-remarks-for-sp
              :text="jobInfo.workSystemText"
              :remarks="jobInfo.officeHours.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.overTime.value"
              title="残業について"
              :text="jobInfo.overTime.value"
            />
          </preview-job-content-section>
          <preview-job-content-section>
            <preview-job-content-title title="勤務地" />
            <preview-job-content-for-sp
              :text="jobInfo.place.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.transportation.value"
              title="交通・詳細"
              :text="jobInfo.transportation.value"
            />
            <preview-job-places-for-sp
              v-if="!jobInfo.isBulkAddressRegistration"
              :places="jobInfo.placeAreaList"
              @toggle="setCheckPoint()"
            />
            <preview-job-content-for-sp
              v-if="!jobInfo.isOnlyFullRemote && jobInfo.isBulkAddressRegistration && !!jobInfo.workplaceAddressListText.value"
              title="勤務地一覧"
              :text="jobInfo.workplaceAddressListText.value"
            />
            <preview-job-content-remarks-for-sp
              v-if="jobInfo.workstyle"
              title="働き方"
              :text="jobInfo.workstyle"
              :remarks="jobInfo.workstyleNote.value"
              :is-workstyle="true"
            />
          </preview-job-content-section>
          <preview-job-content-section>
            <preview-job-content-title title="休日休暇" />
            <preview-job-content-for-sp
              :text="jobInfo.vacation.value"
            />
          </preview-job-content-section>
          <preview-job-content-section>
            <preview-job-content-title title="待遇・福利厚生" />
            <preview-job-content-for-sp
              :text="jobInfo.condition.value"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.smokingRuleText"
              title="喫煙環境"
              :text="jobInfo.smokingRuleText"
            />
            <preview-job-content-for-sp
              v-if="jobInfo.maternityChildcare.value"
              title="産休・育休取得状況"
              :text="jobInfo.maternityChildcare.value"
            />
          </preview-job-content-section>
        </section>
        <div
          id="report"
          ref="report"
          class="mod-inpage-link"
          style="visibility:hidden; height:0;"
        />
        <preview-job-content-section
          v-if="containsAnyOfficeReports"
          class="report mod-job-sugao"
          data-test="office-reports"
        >
          <preview-job-content-title title="もっと知りたい！会社の素顔" />
          <div
            v-if="showFreeArticle"
            class="mod-article-inner"
            data-test="free-article"
          >
            <preview-job-content-header :title="freeArticleTitle" />
            <preview-job-company-topic-for-sp
              v-if="companyInterview.topicsTitle1.value"
              class="mb25"
              :title="companyInterview.topicsTitle1.value"
              :body="companyInterview.topicsBody1.value"
              :photo-id="companyInterview.topicsPhotoId1"
              :photo-caption="companyInterview.topicsPhotoCaption1.value"
              @onLoadImage="onLoadImageAction()"
            />
            <preview-job-company-topic-for-sp
              v-if="companyInterview.topicsTitle2.value"
              :title="companyInterview.topicsTitle2.value"
              :body="companyInterview.topicsBody2.value"
              :photo-id="companyInterview.topicsPhotoId2"
              :photo-caption="companyInterview.topicsPhotoCaption2.value"
              @onLoadImage="onLoadImageAction()"
            />
          </div>
          <div
            v-if="showInterviewArea"
            class="mod-article-inner"
            data-test="interview-area"
          >
            <template v-if="companyInterview.interviewBody.value">
              <preview-job-content-header title="取材担当者より" />
              <p
                class="pega-pre-wrap"
                data-test="interview-body"
                v-text="companyInterview.interviewBody.value"
              />
            </template>
            <preview-job-company-photos-for-sp
              v-if="showPhotoArea"
              :photos="photos"
              @onLoadImage="onLoadImageAction()"
            />
          </div>
        </preview-job-content-section>
        <preview-job-content-section class="mod-company-info">
          <preview-job-content-title title="会社概要" />
          <preview-job-content-for-sp
            title="事業内容"
            :text="companyInfo.companyDescription.value"
          />
          <preview-job-content-for-sp
            v-if="companyInfo.mediaCoverage.value"
            title="事業・サービスのメディア掲載実績・受賞歴"
            :text="companyInfo.mediaCoverage.value"
          />
          <preview-job-content-for-sp
            v-if="companyInfo.mainClient.value"
            title="主要取引先"
            :text="companyInfo.mainClient.value"
          />
          <preview-job-content-for-sp
            v-if="companyInfo.established.value"
            title="設立"
            :text="companyInfo.established.value"
          />
          <preview-job-content-for-sp
            v-if="containsAnyEmployeeDetails"
            title="従業員数"
            :text="employeeDetailsText"
          />
          <preview-job-content-for-sp
            v-if="companyInfo.capital.value"
            title="資本金"
            :text="companyInfo.capital.value"
          />
          <preview-job-content-for-sp
            v-if="companyInfo.salesAmount.value"
            title="売上高"
            :text="companyInfo.salesAmount.value"
          />
          <preview-job-content-for-sp
            v-if="companyInfo.presidentName.value"
            title="代表者"
            :text="presidentDataText"
          />
        </preview-job-content-section>
        <div
          id="procedure"
          ref="procedure"
          class="mod-inpage-link"
          style="visibility:hidden; height:0;"
        />
        <preview-job-content-section class="mod-choice-process">
          <preview-job-content-title title="応募について" />
          <preview-job-process-for-sp
            :entry-process="aboutApply.entryProcess"
          />
          <preview-job-content-for-sp
            v-if="aboutApply.homepageUrl"
            title="ホームページ"
            :text="homepageText"
          />
          <preview-job-content-for-sp
            title="連絡先"
            :text="addressText"
          />
          <preview-job-links-for-sp
            v-if="aboutApply.links.length"
            :links="aboutApply.links"
          />
        </preview-job-content-section>
        <preview-job-tab-for-sp class="foot" />
        <preview-job-detail-button-area-for-sp
          ref="hideDetailButton"
          class="bottom mt15 mb15"
          :entry-form-type="jobInfo.entryFormType"
          :can-casual-interview="jobInfo.canCasualInterview"
        />
      </div>
    </main>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import _ from 'lodash'
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'
import PreviewJobHeaderForSp from '@/components/molecules/PreviewJobHeaderForSp'
import PreviewJobTabForSp from '@/components/molecules/PreviewJobTabForSp'
import PreviewJobDetailButtonAreaForSp from '@/components/molecules/PreviewJobDetailButtonAreaForSp'
import PreviewJobMainArticleForSp from '@/components/molecules/PreviewJobMainArticleForSp'
import PreviewJobContentForSp from '@/components/molecules/PreviewJobContentForSp'
import PreviewJobContentTimeScheduleForSp from '@/components/molecules/PreviewJobContentTimeScheduleForSp'
import PreviewJobContentOrientsForSp from '@/components/molecules/PreviewJobContentOrientsForSp'
import PreviewJobPlacesForSp from '@/components/molecules/PreviewJobPlacesForSp'
import PreviewJobContentRemarksForSp from '@/components/molecules/PreviewJobContentRemarksForSp'
import PreviewJobCompanyTopicForSp from '@/components/molecules/PreviewJobCompanyTopicForSp'
import PreviewJobCompanyPhotosForSp from '@/components/molecules/PreviewJobCompanyPhotosForSp'
import PreviewJobProcessForSp from '@/components/molecules/PreviewJobProcessForSp'
import PreviewJobLinksForSp from '@/components/molecules/PreviewJobLinksForSp'
import PreviewJobContentSection from '@/components/atoms/PreviewJobContentSection'
import PreviewJobContentTitle from '@/components/atoms/PreviewJobContentTitle'
import PreviewJobContentHeader from '@/components/atoms/PreviewJobContentHeader'
import PreviewJobRibbon from '@/components/atoms/PreviewJobRibbon'

export default {
  components: {
    PreviewJobHeaderForSp,
    PreviewJobTabForSp,
    PreviewJobDetailButtonAreaForSp,
    PreviewJobMainArticleForSp,
    PreviewJobContentForSp,
    PreviewJobContentSection,
    PreviewJobContentTitle,
    PreviewJobContentHeader,
    PreviewJobRibbon,
    PreviewJobContentTimeScheduleForSp,
    PreviewJobContentOrientsForSp,
    PreviewJobPlacesForSp,
    PreviewJobContentRemarksForSp,
    PreviewJobCompanyTopicForSp,
    PreviewJobCompanyPhotosForSp,
    PreviewJobProcessForSp,
    PreviewJobLinksForSp
  },
  mixins: [jobPreviewVisibilityCommon],
  props: {
    jobInfo: {
      type: Object,
      required: true
    },
    companyInterview: {
      type: Object,
      required: true
    },
    companyInfo: {
      type: Object,
      required: true
    },
    aboutApply: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      ticking: false,
      scrollY: 0,
      detailButtonDist: 0,
      showDetailButtonY: 0,
      hideDetailButtonY: 0,
      menubarDist: 0,
      menubarY: 0,
      menubarYMap: {
        description: 0,
        qualification: 0,
        report: 0,
        procedure: 0
      },
      callOnLoadImageCount: 0
    }
  },
  computed: {
    imageCount () {
      let imageCount = 0
      if (this.jobInfo.mainPhotoId) imageCount++
      if (this.companyInterview.topicsPhotoId1)imageCount++
      if (this.companyInterview.topicsPhotoId2)imageCount++
      if (this.companyInterview.sugaoPhoto1)imageCount++
      if (this.companyInterview.sugaoPhoto2)imageCount++
      if (this.companyInterview.sugaoPhoto3)imageCount++
      return imageCount
    },
    showInterviewArea () {
      return this.companyInterview.interviewBody.value || this.showPhotoArea
    },
    showDetailButton () {
      return this.scrollY + this.detailButtonDist >= this.showDetailButtonY && this.scrollY + this.detailButtonDist <= this.hideDetailButtonY
    },
    isCurrentDescription () {
      return this.scrollY + this.menubarDist >= this.menubarYMap.description && this.scrollY + this.menubarDist < this.menubarYMap.qualification
    },
    isCurrentQualification () {
      return this.scrollY + this.menubarDist >= this.menubarYMap.qualification && this.scrollY + this.menubarDist < this.menubarYMap.report
    },
    isCurrentReport () {
      return this.scrollY + this.menubarDist >= this.menubarYMap.report && this.scrollY + this.menubarDist < this.menubarYMap.procedure
    },
    isCurrentProcedure () {
      return this.menubarYMap.procedure && this.scrollY + this.menubarDist >= this.menubarYMap.procedure
    },
    isMenubarFixed () {
      return this.menubarY && this.scrollY >= this.menubarY
    },
    menubarData () {
      return [
        {
          name: '仕事内容',
          scrollTarget: 'description',
          isCurrent: this.isCurrentDescription,
          isShow: true
        },
        {
          name: '応募資格',
          scrollTarget: 'qualification',
          isCurrent: this.isCurrentQualification,
          isShow: true
        },
        {
          name: '会社の素顔',
          scrollTarget: 'report',
          isCurrent: this.isCurrentReport,
          isShow: this.containsAnyOfficeReports
        },
        {
          name: '応募について',
          scrollTarget: 'procedure',
          isCurrent: this.isCurrentProcedure,
          isShow: true
        }
      ]
    },
    photos () {
      return [
        {
          id: this.companyInterview.sugaoPhoto1,
          caption: this.companyInterview.sugaoPhotoCaption1.value
        },
        {
          id: this.companyInterview.sugaoPhoto2,
          caption: this.companyInterview.sugaoPhotoCaption2.value
        },
        {
          id: this.companyInterview.sugaoPhoto3,
          caption: this.companyInterview.sugaoPhotoCaption3.value
        }
      ].filter(i => i.id) // idがないものは除く
    },
    employeeDetailsText () {
      return _.compact([
        this.companyInfo.employeesNum.value,
        this.companyInfo.averageAge.value ? `平均年齢／${this.companyInfo.averageAge.value}` : '',
        this.companyInfo.employeesSexRatio.value ? `男女比／${this.companyInfo.employeesSexRatio.value}` : '',
        this.companyInfo.middleEnterRatio.value ? `中途入社者の割合／${this.companyInfo.middleEnterRatio.value}` : ''
      ]).join('\n')
    },
    presidentDataText () {
      return _.compact([
        this.companyInfo.presidentName.value,
        this.companyInfo.presidentHistory.value ? `代表者略歴／${this.companyInfo.presidentHistory.value}` : ''
      ]).join('\n')
    },
    homepageText () {
      return `${this.companyInfo.companyName}\n<a
                href="${this.aboutApply.homepageUrl}"
                rel="nofollow"
                target="_blank"
              >${this.aboutApply.homepageUrl}</a>`
    },
    addressText () {
      return _.compact([
        `〒${this.aboutApply.zipcode}`,
        this.aboutApply.address.value.trim(),
        this.aboutApply.contactDepartment.value,
        this.aboutApply.tel.value ? `TEL / ${this.aboutApply.tel.value}` : '',
        this.aboutApply.contactEmail.value ? 'E-mail / <a href="javascript:void(0);">企業に問い合わせる</a>' : ''
      ]).join('\n')
    },
    trialPeriodRemarksProps () {
      // 「試用期間」が無しの場合のみ、「雇用形態」の下に「試用期間の雇用形態備考」を表示するオブジェクトを返却
      return !this.jobInfo.trialPeriodText ? { remarks: this.jobInfo.trialPeriodEmploymentStatusRemarks.value } : {}
    }
  },
  mounted () {
    // スクロール縦位置取得
    // document.documentModeの有無でIEか否かを判定
    window.addEventListener('scroll', this.calculateScrollY, !document.documentMode ? { passive: true } : false)

    // ウィンドウリサイズ検知
    window.addEventListener('resize', this.resizeAction)

    // スクロールイベントのチェックポイントの調整値記録
    this.setCheckPointAdjustment()

    if (!this.imageCount) {
      this.onLoadImageAction() // 画像の読み込みがないため、画像読み込み後処理を呼んでおく
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.calculateScrollY, !document.documentMode ? { passive: true } : false)
    window.removeEventListener('resize', this.resizeAction)
  },
  methods: {
    // 画像読み込み後処理
    onLoadImageAction () {
      this.callOnLoadImageCount++
      if (this.imageCount && this.callOnLoadImageCount !== this.imageCount) return// まだ全ての画像がロードされていないため処理を省略

      // 座標の記録
      this.setCheckPoint()
    },
    // 画面リサイズ時処理
    resizeAction () {
      this.setCheckPointAdjustment()
      this.setCheckPoint()
    },
    scrollTo (scrollTarget) {
      window.scrollTo({
        // USERのSP表示がメニューバーと項目のタイトルが若干重なるようになっているため、スクロール位置を-2で補正している
        top: this.menubarYMap[scrollTarget] - (this.menubarDist - 2),
        behavior: 'smooth'
      })
    },
    calculateScrollY () {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.$set(this, 'ticking', false)
          this.$set(this, 'scrollY', window.scrollY)
        })
        this.$set(this, 'ticking', true)
      }
    },
    setCheckPointAdjustment () {
      this.$set(this, 'detailButtonDist', window.innerHeight - this.$refs.hideDetailButton.$el.clientHeight)
      this.$set(this, 'menubarDist', this.$refs.menubar.clientHeight)
      this.$set(this, 'menubarY', this.$refs.menubar.getBoundingClientRect().top)
    },
    async setCheckPoint () {
      await this.$nextTick()
      this.$set(this, 'showDetailButtonY', parseInt(this.$refs.showDetailButton.getBoundingClientRect().top + this.scrollY))
      this.$set(this, 'hideDetailButtonY', parseInt(this.$refs.hideDetailButton.$el.getBoundingClientRect().top + this.scrollY))
      Object.keys(this.menubarYMap).forEach((key) => {
        this.$set(this.menubarYMap, key, parseInt(this.$refs[key].getBoundingClientRect().top + this.scrollY))
      })
    }
  }
}
</script>
